import "reflect-metadata";
import AuthenticationInitiator from "./authentication/AuthenticationInitiator";
import { BackendConfig } from "./config/BackendConfig";
import { container } from "./container";
import { serviceIdentifiers } from "./container-service-identifiers";
import { IAnalyticsService } from "./core/analytics/IAnalyticsService";
import { IGameCanvasStylingService } from "./core/cursor/IGameCanvasStylingService";
import { IFirebaseService } from "./core/firebase/IFirebaseService";
import { IIFrameBrowserService } from "./core/iframe-browser/IIFrameBrowserService";
import { INavigationService } from "./core/navigation/INavigationService";
import ExitConfirmationService from "./core/exit-confirmation/ExitConfirmationService";

export interface UnityInstance {
    Module: Record<string, unknown>;
}

export interface InitParameters {
    unityInstance: UnityInstance;
    iFrameBrowserDivId?: string;
}

/**
 * Starts the authentication process directly on page load, parallel to the loading of the game.
 * Returns false if the user is being redirected to the login page, in which case the game should not be loaded.
 */
export function startAuthentication(): boolean {
    console.log(`Initiating authentication process...`);

    const authenticationInitiator = container.get(serviceIdentifiers.AuthenticationInitiator) as AuthenticationInitiator;
    authenticationInitiator.authenticate();

    // NOTE: authenticate() redirects synchronously (before its first await) when no API ticket is present,
    // so the redirecting flag is already up to date here.
    return !authenticationInitiator.isRedirecting;
}

export function init(initParameters: InitParameters) {
    console.log(`Initializing ranj native web bundle...`);

    const ranjLib = {
        firebase: container.get(serviceIdentifiers.IFirebaseService) as IFirebaseService,
        analytics: container.get(serviceIdentifiers.IAnalyticsService) as IAnalyticsService,
        iframeBrowser: container.get(serviceIdentifiers.IIFrameBrowserService) as IIFrameBrowserService,
        navigation: container.get(serviceIdentifiers.INavigationService) as INavigationService,
        gameCanvasStyling: container.get(serviceIdentifiers.IGameCanvasStylingService) as IGameCanvasStylingService,
        authenticationInitiator: container.get(serviceIdentifiers.AuthenticationInitiator) as AuthenticationInitiator,
        exitConfirmationService: container.get(serviceIdentifiers.ExitConfirmationService) as ExitConfirmationService,
    };

    if (!!initParameters.iFrameBrowserDivId) {
        ranjLib.iframeBrowser.initialize(initParameters.iFrameBrowserDivId);
    }

    initParameters.unityInstance.Module.ranj = ranjLib;

    console.log(`Ranj native web bundle initialized.`);
    console.log(`Backend url: ${BackendConfig.backendRestApiAddress}`);
    console.log(`Student login url: ${BackendConfig.studentLoginAddress}`);

    ranjLib.exitConfirmationService.initialize();
}